import ChattaCommunityCategoriesScreen from '~components/new-chat/school'

export default ChattaCommunityCategoriesScreen
